module.exports = __webpack_public_path__ + "img/meun.82d4b17b.svg";